import { render, staticRenderFns } from "./OcpcSetList.vue?vue&type=template&id=ec00e21e"
import script from "./OcpcSetList.vue?vue&type=script&lang=js"
export * from "./OcpcSetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports